const eventTypesPreferences = [
    {name: 'Gratuito', value: 'free'} ,
    {name: 'Pago', value: 'paid'},
    {name: 'Ambos / Indiferente', value: 'both'} 
]
export default eventTypesPreferences;